export default __webpack_public_path__ + "aade47b475b84421ba732dc41d802fab.svg";